
<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <img class="Form__thank_img" src="assets/img/unsubscribe.png" alt="ok">
          <p class="Form__tx">
            クレジットカードのエラーで、決済できない状態になっています。<br>この状態が続くと、アカウントがロックされてサービスを利用できなくなってしまいますので、下のボタンよりご確認をお願いいたします。
          </p>
          <a href="/change" class="Btn__blue Btn__blue--lg Form__btn--mt_md Form__btn--mt_sp_sm">確認・変更はこちらから</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CreditCard'
}
</script>
